import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { getAddress } from '../services/addressService';

/**
 * Hook para buscar endereços digitados pelo usuário.
 *
 * @param initialValue Valor inicial do input de busca.
 */
export function useAddressSearch(initialValue = '') {
  const [searchInput, setSearchInput] = useState(initialValue);
  const [debouncedFilter] = useDebounce(searchInput, 800);
  const [addressesList, setAddressesList] = useState<any[]>([]);
  const [isSearchCompleted, setIsSearchCompleted] = useState(false);

  useEffect(() => {
    const fetchAddresses = async (address: string) => {
      try {
        const addresses = await getAddress(address);
        setAddressesList(addresses);
        setIsSearchCompleted(true);
      } catch (error) {
        console.error('Erro ao consultar endereço', error);
        setIsSearchCompleted(true);
      }
    };

    if (searchInput.trim()) {
      setIsSearchCompleted(false);
      fetchAddresses(searchInput);
    } else {
      setAddressesList([]);
      setIsSearchCompleted(false);
    }
  }, [debouncedFilter]);

  return {
    searchInput,
    setSearchInput,
    addressesList,
    isSearchCompleted,
  };
}
